import { POPPER_HELPER } from "../core/constants";
import { store } from "../core/state";
import { setComponentData } from "../core/views";
import { getCursorPixel } from "./MonacoEditorHelper";

export const setPopperHelper = (helperData) => {
  let height = 1;
  if (helperData.height) {
    height = helperData.height;
  }

  let width = 1;
  if (helperData.width) {
    width = helperData.width;
  }

  let top = 1;
  if (helperData.top) {
    top = helperData.top;
  }
  let left = 150;
  if (helperData.left) {
    left = helperData.left;
  }

  if (helperData.position === "aceCursor") {
    const row = helperData.ace.args[0] + 1
    const col = helperData.ace.args[1]
    const cursorPosition = getCursorPixel(row, col);
    const offset = 5;
    top = cursorPosition.top + offset;
    const gutter = 44;
    left = cursorPosition.left + gutter + offset;
  }

  const helperState = {
    height, width, top, left
  }
  console.log("setPopperHelper", helperState)
  setComponentData(POPPER_HELPER, helperState)
}

export const PopperHelper = () => {
  const [helperStyle, setHelperStyle] = store.useState(POPPER_HELPER);
  if (!helperStyle) {
    return null;
  }
  return <p id="popperHelper" style={{
    position: "absolute",
    height: `${helperStyle.height}px`,
    width: `${helperStyle.width}px`,
    top: `${helperStyle.top}px`,
    left: `${helperStyle.left}px`,
  }}></p>
}
